import React from 'react';

import '../styles/auth.css';

import { EmailInputProps } from '../types/auth';

export const EmailInput: React.FC<EmailInputProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  readOnly,
}) => (
  <input
    type="email"
    className={`email-input${readOnly ? ' email-input--readonly' : ''}`}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    onFocus={onFocus}
    onBlur={onBlur}
    disabled={disabled}
    readOnly={readOnly}
    placeholder="Email address"
    aria-label="Email address"
  />
);
